import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { Link } from "react-router-dom";

export default function GeneralLinks() {
  //  Define route and label
  const pages = [
    { label: "About", path: "/about" },
    { label: "Contact Us", path: "/contact" },
  ];

  return (
    <MKBox flex={1} minWidth={160}>
      <MKTypography variant="h6" fontWeight="bold" mb={0.5}>
        General
      </MKTypography>

      {/*  Render each link */}
      {pages.map((item, i) => (
        <MKTypography key={i} variant="body2" mb={0.5}>
          <Link to={item.path} style={{ color: "inherit", textDecoration: "none" }}>
            {item.label}
          </Link>
        </MKTypography>
      ))}
    </MKBox>
  );
}
